import ActionTypes from "../../constant/constant";
import axios from "axios";
import Courses from "../../../component/homePage/Courses";
// const api = "http://localhost:5000/";
const api = "https://api.jawanpakistan.com/";

const addNewCourseData =
  (
    city,
    cityCode,
    course,
    courseId,
    batch,
    institute,
    instituteCode,
    lastDate,
    courseDura,
    courseStatus,
    courseSlots,
    instructions,
    price,
    cardExpiry
  ) =>
  async (dispatch) => {
    dispatch({ type: "COURSE_DATA_REQUEST" });
    const obj = {
      cityName: city,
      cityCode: cityCode,
      instituteName: institute,
      instituteCode: instituteCode,
      courseName: course,
      courseCode: courseId,
      batchNo: batch,
      viewForm: courseStatus,
      year: String(new Date().getFullYear()).slice(2),
      duration: courseDura + " " + "Months",
      admissionLastDate: lastDate,
      timings: courseSlots,
      instructions: JSON.stringify(instructions),
      price: price,
      cardExpiry:cardExpiry,
    };
    console.log(obj);
    const options = {
      method: "POST",
      headers: { Accept: "application/json" },
      data: obj,
      // url: `http://localhost:5000/registration/addCourseAnoouce`,
      url: `${api}registration/addCourseAnoouce`,
    };
    axios(options)
      .then((res) => {
        console.log(res);
        dispatch({ type: "COURSE_DATA_SUCCESS", payload: res.data });
      })
      .catch((error) => {
        console.log(error);
        dispatch({
          type: "COURSE_DATA_FAIL",
          payload:
            error.response && error.response.data.message
              ? error.response.data.message
              : error.message,
        });
      });
  };

const emptyMessage = () => {
  return (dispatch) => {
    dispatch({ type: "EMPTY_MESSAGE" });
  };
};
const getAllCourse = () => async (dispatch) => {
  dispatch({ type: "GETTING_COURSES" });
  axios
    .get(`${api}registration/getCourseAnoouce`)
    .then((res) => {
      console.log(res);
      dispatch({ type: "ALL_COURSES_REQUEST", payload: res.data.data });
      // setCourseList(res.data.data);
    })
    .catch((err) => {
      console.log(err, "err");
      dispatch({ type: "COURSES_NOT FOUND", payload: "No Data Found" });
    });
};

export { addNewCourseData, emptyMessage, getAllCourse };
